// src/ReturnFlight.tsx
import { createIcon } from "@chakra-ui/icon";
import { Fragment, jsx, jsxs } from "react/jsx-runtime";
var ReturnFlight_default = createIcon({
  displayName: "ReturnFlight",
  viewBox: "0 0 24 24",
  path: /* @__PURE__ */ jsxs(Fragment, {
    children: [
      /* @__PURE__ */ jsx("rect", {
        opacity: "0",
        width: "24",
        height: "24",
        fill: "white",
        fillOpacity: "0"
      }),
      /* @__PURE__ */ jsx("path", {
        d: "M17 7H7.00001V10C7.00001 10.55 6.55001 11 6.00001 11C5.45001 11 5.00001 10.55 5.00001 10V6C5.00001 5.45 5.45001 5 6.00001 5H17V3.21C17 2.76 17.54 2.54 17.85 2.85L20.64 5.64C20.84 5.84 20.84 6.15 20.64 6.35L17.85 9.14C17.54 9.46 17 9.24 17 8.79V7ZM7.00001 17H17V14C17 13.45 17.45 13 18 13C18.55 13 19 13.45 19 14V18C19 18.55 18.55 19 18 19H7.00001V20.79C7.00001 21.24 6.46001 21.46 6.15001 21.15L3.36001 18.36C3.16001 18.16 3.16001 17.85 3.36001 17.65L6.15001 14.86C6.46001 14.54 7.00001 14.76 7.00001 15.21V17Z",
        fillRule: "evenodd",
        clipRule: "evenodd",
        fill: "currentColor"
      })
    ]
  })
});

export {
  ReturnFlight_default
};
